<template>
  <div class="p-item-carousel" :class="[`p-item-carousel--${carouselName}`]">
    <div v-show="!isSp">
      <div class="p-item-carousel__button p-item-carousel__button--prev">
        <div class="p-item-carousel__button__icon__wrap">
          <IconBase
            class="p-item-carousel__button__icon"
            view-box="0 0 24 24"
            width="24"
            height="24"
          >
            <IconArrowLeft />
          </IconBase>
        </div>
      </div>
      <div class="p-item-carousel__button p-item-carousel__button--next">
        <div class="p-item-carousel__button__icon__wrap">
          <IconBase
            class="p-item-carousel__button__icon"
            view-box="0 0 24 24"
            width="24"
            height="24"
          >
            <IconArrowRight />
          </IconBase>
        </div>
      </div>
      <AppSwiper class="swiper" :options="swiperOption">
        <SwiperSlide v-for="(item, key) in itemList" :key="key">
          <ItemListPanel
            :id="item.id"
            :img-path="item.image"
            :name="item.name"
            :point="item.point"
            :discount-rate="item.discount_rate"
            :is-favorite="item.is_favorite"
            :color="item.colorCode"
            :status="item.status"
            :stock="item.stock"
            :stock-control="item.is_quantity_control"
          />
        </SwiperSlide>
      </AppSwiper>
    </div>

    <div v-show="isSp" class="p-item-carousel__sp_lists">
      <div
        v-for="(item, key) in itemList"
        :key="`${key}_sp`"
        class="p-item-carousel__panel"
      >
        <ItemListPanel
          v-if="key < 4"
          :id="`${item.id}_sp`"
          :img-path="item.image"
          :name="item.name"
          :point="item.point"
          :discount-rate="item.discount_rate"
          :is-favorite="item.is_favorite"
          :status="item.status"
          :color="item.colorCode"
          :stock="item.stock"
          :stock-control="item.is_quantity_control"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ItemListPanel from "@/general/components/molecules/ItemListPanel.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowLeft from "@/common/components/icons/IconArrowLeft.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";

import { Options, Vue } from "vue-class-component";
import globals from "@/general/store/modules/globals";
import { SwiperOptions, Swiper as SwipeClass, Navigation } from "swiper";

interface ExtendedSwiperOptions extends SwiperOptions {
  loopFillGroupWithBlank?: boolean;
}

@Options({
  props: {
    itemList: { type: Array, required: false },
    carouselName: { type: String, required: false, default: "default" }
  },
  components: {
    ItemListPanel,
    IconBase,
    IconArrowLeft,
    IconArrowRight,
    Swiper,
    SwiperSlide
  }
})
export default class ItemCarousel extends Vue {
  itemList!: any;
  carouselName!: string;

  swiperOption: ExtendedSwiperOptions = {
    slidesPerView: 4,
    spaceBetween: 16,
    slidesPerGroup: 4,
    // loop: true, // NOTICE: If set to true, click event will not be cloned.
    loopFillGroupWithBlank: true,
    navigation: {
      nextEl: `.p-item-carousel--${this.carouselName} .p-item-carousel__button--next`,
      prevEl: `.p-item-carousel--${this.carouselName} .p-item-carousel__button--prev`
    },
    watchOverflow: true
  };

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }
}
</script>

<style lang="scss" scoped>
.p-item-carousel {
  position: relative;
  padding: 0 rem(56);

  @include large-sp {
    padding: 0;
  }

  &__sp_lists {
    display: flex;
    flex-wrap: wrap;
    margin: rem(-8) rem(-8) 0 0;
  }

  &__panel {
    padding: rem(8) rem(8) 0 0;
    width: 50%;
  }

  &__button {
    position: absolute;
    top: 0;
    bottom: rem(24);
    z-index: 1;
    margin: auto;
    width: rem(48);
    height: rem(48);
    padding: rem(10);
    cursor: pointer;

    &.swiper-button-disabled {
      opacity: 0.3;
      cursor: default;
    }

    &__icon {
      color: $common-gray700;

      &__wrap {
        width: rem(28);
        height: rem(28);
        padding: rem(2);
        border-radius: 50%;
        background: #ffffff;
        box-shadow: 0 0 px(10) rgba(0, 0, 0, 0.25);
      }
    }

    &--prev {
      left: 0;
    }
    &--next {
      right: 0;
    }
  }
}
</style>
